import { useEffect, useRef, useState } from 'react'

export const useMouse = () => {
  const [mouse, setMouse] = useState<MouseEvent | null>(null)
  const mouseRef = useRef<MouseEvent | null>(null)
  const animationFrameRef = useRef<number | null>(null)

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      mouseRef.current = event
      if (animationFrameRef.current === null) {
        animationFrameRef.current = requestAnimationFrame(() => {
          setMouse(mouseRef.current)
          animationFrameRef.current = null
        })
      }
    }

    window.addEventListener('mousemove', handleMouseMove)

    return () => {
      window.removeEventListener('mousemove', handleMouseMove)
      if (animationFrameRef.current !== null) {
        cancelAnimationFrame(animationFrameRef.current)
      }
    }
  }, [])

  return mouse
}
